import React, { Component } from 'react'; 
class IsAuth extends Component {
    render() {
        if (this.props.isView) {
            return this.props.children
        }

        return this.props.defaultComponent
    }
}

export default IsAuth;


// WEBPACK FOOTER //
// ./src/components/app/IsAuth.js